export default {
  name: 'marking--Counterparty',
  apiService: 'shoes',
  apiPath: '/admin/counterparty',
};